.chart {
  display: flex;
  flex-direction: row;
  gap: var(--tuna-spacing-1);
  width: 100%;
  min-height: 96px;
  padding: var(--tuna-spacing-2) 0;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3);
  border: none;
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  color: var(--tuna-content-onPalette, #fff);
  font-family: inherit;
  transition: opacity 150ms ease-in-out;
}

.chart[data-has-active='true'] .block {
  opacity: 0.5;
}

.chart[data-has-active='true'] .block[aria-current='step'] {
  opacity: 1;
  outline: 4px solid var(--tuna-feedback-focus-outline, var(--tuna-palette-primary-500));
  outline-offset: -4px;
}

.block:hover {
  outline: 2px solid var(--tuna-feedback-focus-outline, var(--tuna-palette-primary-500));
}

.blockLabel {
  font-size: var(--tuna-typography-body-fontSize);
  font-weight: 600;
}

.blockBars {
  font-size: var(--tuna-typography-caption-fontSize);
  opacity: 0.9;
}

@media (prefers-reduced-motion: reduce) {
  .block {
    transition: none;
  }
}
